export const ContactConfig = {
    email: "info@njhrxl.com",
    phone: "+924237188553",
    facebook: "https://www.facebook.com/people/Nauman-Javed-Hasnain-Rashid-Chartered-Accountants/100089067699650/?mibextid=wwXIfr&rdid=vALf7eON08S5xSWh&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1BmXWWEZDM%2F%3Fmibextid%3DwwXIfr",
    linkedin: "https://www.linkedin.com/company/nauman-javed-hasnain-rashid-chartered-accountants/",
    addressLink: "https://maps.app.goo.gl/89umE8yCP7HGW11EA"
};


export const contactResources = {
    en: {
        Title: "Let’s Transform Your Finance Function",
        Description:
            "We would love to receive your message, questions, and feedback. Our team is ready to assist you. Please fill out the form below and we will get back to you as soon as possible.",
        FullNameLabel: "Full Name",
        FullNamePlaceholder: "Enter your full name",
        EmailLabel: "Email",
        EmailPlaceholder: "Enter your email address",
        PhoneLabel: "Phone",
        PhonePlaceholder: "Enter your phone number",
        InterestLabel: "Area of Interest",
        OtherOption: "Other",
        MessageLabel: "Message",
        MessagePlaceholder: "Type your message here...",
        SubmitButton: "Schedule a Consultation",
        EmailSubject: "Contact Form Submission",
        Address: "First Floor, Plaza No. 29 Broadway, Paragon Housing Society, Barki Road, Lahore, Pakistan",
        linkedin: "LinkedIn",
        facebook: "Facebook",
        SocialMedia: "Social Media",
    },
    ar: {
        Title: "دعونا نُحوّل وظيفة المالية الخاصة بك",
        Description:
            "نود أن نتلقى رسالتك وأسئلتك وملاحظاتك. فريقنا جاهز لمساعدتك. يرجى ملء النموذج أدناه وسنقوم بالرد في أقرب وقت ممكن.",
        FullNameLabel: "الاسم الكامل",
        FullNamePlaceholder: "أدخل اسمك الكامل",
        EmailLabel: "البريد الإلكتروني",
        EmailPlaceholder: "أدخل بريدك الإلكتروني",
        PhoneLabel: "الهاتف",
        PhonePlaceholder: "أدخل رقم هاتفك",
        InterestLabel: "مجال الاهتمام",
        OtherOption: "أخرى",
        MessageLabel: "الرسالة",
        MessagePlaceholder: "اكتب رسالتك هنا...",
        SubmitButton: "حدد موعد استشارة",
        EmailSubject: "نموذج الاتصال",
        Address: "الطابق الأول، بلازا رقم 29 برودواي، مجتمع باراجون السكني، طريق باركي، لاهور، باكستان",
        linkedin: "لينكدإن",
        facebook: "فيسبوك",
        SocialMedia: "وسائل التواصل",
    }
};
